export default "__VITE_ASSET__0eb06efa__"